import {paginationInit} from '../../js/partials/pagination';
import {scrollIntoView} from '../../js/utils/scrollIntoView';
import {createNewUrl} from '../../js/utils/createNewUrl';
import {initProductImageChange} from '../../js/utils/changeProductImage';

const fetchAndUpdateContent = function(pageUrl) {
    const collectionMainElement = document.querySelector('[data-js-selector="collection-main"]');
    collectionMainElement.setAttribute('data-loading', true);
    fetch(pageUrl)
        .then((response) => {
            if (!response.ok) {
                collectionMainElement.setAttribute('data-loading', false);
                throw new Error('Network response was not ok');
            }
            return response.text();
        })
        .then((htmlString) => {
            const parser = new DOMParser();
            const html = parser.parseFromString(htmlString, 'text/html');

            const oldSections = document.querySelectorAll('.refreshWithSorting');
            const newSections = html.querySelectorAll('.refreshWithSorting');
            oldSections.forEach((oldSection, index) => {
                const newSection = newSections[index];
                oldSection.innerHTML = newSection.innerHTML;
            });
            paginationInit();
            sortingInit();
            collectionMainElement.setAttribute('data-loading', false);
            scrollIntoView('[data-js-selector="collection-main-products"]');
            initProductImageChange();
        })
        .catch((error) => {
            console.error('Fetch error:', error);
            collectionMainElement.setAttribute('data-loading', false);
        });
};


/*
    EX-1209 / EX-1213 Updates :
    changed logic here because of the following:
    - URLSearchParams automatically decodes URL parameters
    - this breaks complex filter values containing encoded commas (%2C)
    - also it includes the comma separating the filter values when decoding/re-encoding
    - when these values are re-encoded, the original formatting is lost & filter/page is broken

    fix implemented:
    - we manually parse URL parameters without decoding them
    - and preserve the exact encoding of all values, especially commas between filter values
    - then rebuild the full url correctly with all original encodings without changing it
*/

const handleSortingButtonClick = (event) => {
    const dataValue = event.currentTarget.dataset.value;
    if (dataValue) {
        // Get the base URL (everything before the query string)
        const baseUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
        
        // Get the current search parameters as a string (without the leading '?')
        const searchString = window.location.search.substring(1);
        
        // Parse the parameters into an object for easier manipulation while preserving encoding
        const params = {};
        if (searchString) {
            // Split the query string by '&' to get individual key-value pairs
            searchString.split('&').forEach(pair => {
                // find position of the first '=' character
                // we maybe have a = in the value, so we use indexOf instead of split to properly handle this case
                const equalsPosition = pair.indexOf('=');
                
                // only process if we found valid key&value
                if (equalsPosition !== -1) {
                    const key = pair.substring(0, equalsPosition);
                    
                    // extract the value, this we'll keep = if there are any
                    const value = pair.substring(equalsPosition + 1);
                    
                    // store the parameter without modifying its encoding
                    params[key] = value;
                }
            });
        }
        
        // update sort_by value and delete page
        params['sort_by'] = dataValue;
        delete params['page'];
        
        // reconstruct the query string
        const newQueryString = Object.keys(params)
            .map(key => `${key}=${params[key]}`)
            .join('&');
        
        // build the new correct url
        const newUrl = baseUrl + (newQueryString ? `?${newQueryString}` : '');
    
        window.history.pushState({path: newUrl}, '', newUrl);
        fetchAndUpdateContent(newUrl);
    }
};

const handleToggleClick = function(event) {
    if (window.innerWidth >= sga.breakpointVariables.mediumUp) return;
    
    event.preventDefault();
    event.stopPropagation();
    
    const currentToggle = event.currentTarget;
    const wasOpen = currentToggle.classList.contains('is-open');
    
    // close all toggles first
    document.querySelectorAll('.js-sorting-toggle.is-open').forEach(toggle => {
        toggle.classList.remove('is-open');
    });
    
    // if the clicked toggle wasn't open before, open it now
    if (!wasOpen) {
        currentToggle.classList.add('is-open');
    }
};

const handleDocumentClick = function(event) {
    if (window.innerWidth >= sga.breakpointVariables.mediumUp) return;
    
    if (!event.target.closest('.js-sorting-toggle')) {
        document.querySelectorAll('.js-sorting-toggle.is-open').forEach(toggle => {
            toggle.classList.remove('is-open');
        });
    }
};

export const sortingInit = () => {
    // Clean up all existing event listeners
    document.removeEventListener('click', handleDocumentClick);
    // reattach document click handler for mobile dropdown
    document.addEventListener('click', handleDocumentClick);
    const sortingToggles = document.querySelectorAll('.js-sorting-toggle');
    sortingToggles.forEach(toggle => {
        // remove existing click listeners
        const toggleClone = toggle.cloneNode(true);
        toggle.parentNode.replaceChild(toggleClone, toggle);
        // add new click listener
        toggleClone.addEventListener('click', handleToggleClick);
    });

    // Handle sorting button clicks for both mobile and desktop
    const sortingButtons = document.querySelectorAll('.js-sorting-button');
    sortingButtons.forEach(button => {
        // remove all existing click listeners
        const buttonClone = button.cloneNode(true);
        button.parentNode.replaceChild(buttonClone, button);
        
        if (!buttonClone.classList.contains('active')) {
            buttonClone.addEventListener('click', handleSortingButtonClick);
        }
    });
};